/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type { GetReviewAverageByProductIdServerParams, ReviewAverageDTO } from '@as-react/common-types/review-service';
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import { queryFetch } from '../../utils/orval/queryFetch';
import type { ErrorType } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Finds the review average for the given product on the given webshop.
 */
export const getReviewAverageByProductIdServer = (
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName = 'getReviewAverageByProductId',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<ReviewAverageDTO>(
    { url: `/public/review/average/v2/${productId}`, method: 'GET', params, signal },
    { operationName: 'getReviewAverageByProductId', service: 'review-service', ...options }
  );
};

export const useGetReviewAverageByProductIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
  TError = ErrorType<ReviewAverageDTO>,
>(
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName = 'getReviewAverageByProductId',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { productId, params, operationName },
    { url: `/public/review/average/v2/${productId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>> = ({ signal }) =>
    getReviewAverageByProductIdServer(productId, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReviewAverageByProductIdServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>
>;
export type GetReviewAverageByProductIdServerQueryError = ErrorType<ReviewAverageDTO>;

export function useGetReviewAverageByProductIdServer<
  TData = Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
  TError = ErrorType<ReviewAverageDTO>,
>(
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
          TError,
          Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReviewAverageByProductIdServer<
  TData = Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
  TError = ErrorType<ReviewAverageDTO>,
>(
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
          TError,
          Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReviewAverageByProductIdServer<
  TData = Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
  TError = ErrorType<ReviewAverageDTO>,
>(
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Finds the review average for the given product on the given webshop.
 */

export function useGetReviewAverageByProductIdServer<
  TData = Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
  TError = ErrorType<ReviewAverageDTO>,
>(
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName = 'getReviewAverageByProductId',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReviewAverageByProductIdServerQueryOptions(productId, params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
